import styles from './noti.module.scss'

export const Notification = ({ description, title, error, reason }: any) => {
  return (
    <div className={styles.container}>
      {
        error ? 
        <div className={styles.main_error}>
          <h2>{title}</h2>
          <p>{description}</p>
          <p>{reason}</p>
        </div>
        : 
        <div className={styles.main_ok}>
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
      }
    </div>
  )
}